// public/js/features/alerts/api.js
// Thin wrappers around the alert REST endpoints + the client-side metric catalog
// (kept in sync with utils/alerts/metrics.mjs on the server).

export const ALERT_METRICS = [
  { key: 'temperature',    label: 'Temperature',    unit: '°C' },
  { key: 'probe1Temp',     label: 'Probe 1 temp',   unit: '°C' },
  { key: 'probe2Temp',     label: 'Probe 2 temp',   unit: '°C' },
  { key: 'humidity',       label: 'Humidity',       unit: '%' },
  { key: 'pressure',       label: 'Pressure',       unit: 'hPa' },
  { key: 'battery',        label: 'Battery',        unit: 'V' },
  { key: 'batteryPercent', label: 'Battery charge', unit: '%' },
  { key: 'rssi',           label: 'Signal (RSSI)',  unit: 'dBm' },
  // The LEVEL of a BLE pair, not a single read - the one to alert on, because a
  // threshold on raw rssi fires on every fade. docs/ble-sensors.md section 4.
  { key: 'rssiAvg',        label: 'Signal level (RSSI avg)', unit: 'dBm' },
  { key: 'rssiSpread',     label: 'Signal spread (RSSI)',    unit: 'dB' },
  { key: 'rssiFloor',      label: 'Signal floor (RSSI)',     unit: 'dBm' },
  { key: 'speed',          label: 'Speed',          unit: 'km/h' },
  { key: 'fuelLevel',      label: 'Fuel level',     unit: '%' },
  { key: 'distanceM',      label: 'Distance (ToF)', unit: 'm' },
  { key: 'peakG',          label: 'Shock / Impact', unit: 'g' },
  { key: 'geofence',       label: 'Geofence (POI)', unit: '' },
];

export const metricByKey = (k) => ALERT_METRICS.find(m => m.key === k);

export const ALERT_OPERATORS = [
  { op: '>',  label: 'greater than (>)' },
  { op: '>=', label: 'at least (≥)' },
  { op: '<',  label: 'less than (<)' },
  { op: '<=', label: 'at most (≤)' },
  { op: '==', label: 'equals (=)' },
  { op: 'outside', label: 'outside range' },
  { op: 'inside',  label: 'inside range' },
];

async function jsonOrThrow(res) {
  if (!res.ok) {
    let msg = `HTTP ${res.status}`;
    try { msg = (await res.json()).error || msg; } catch {}
    throw new Error(msg);
  }
  return res.json();
}

export async function listAlerts() {
  return (await jsonOrThrow(await window.authenticatedFetch('api/v1/alerts'))).alerts || [];
}
export async function createAlert(data) {
  return jsonOrThrow(await window.authenticatedFetch('api/v1/alerts', {
    method: 'POST', headers: { 'Content-Type': 'application/json' }, body: JSON.stringify(data),
  }));
}
export async function updateAlert(alertId, updates) {
  return jsonOrThrow(await window.authenticatedFetch(`api/v1/alerts/${encodeURIComponent(alertId)}`, {
    method: 'PATCH', headers: { 'Content-Type': 'application/json' }, body: JSON.stringify(updates),
  }));
}
export async function deleteAlert(alertId) {
  return jsonOrThrow(await window.authenticatedFetch(`api/v1/alerts/${encodeURIComponent(alertId)}`, { method: 'DELETE' }));
}
export async function listAlertEvents({ status = null, since = null, limit = 200 } = {}) {
  const qs = new URLSearchParams();
  if (status) qs.set('status', status);
  if (since) qs.set('since', since);
  if (limit) qs.set('limit', String(limit));
  const url = 'api/v1/alerts/events' + (qs.toString() ? `?${qs}` : '');
  return (await jsonOrThrow(await window.authenticatedFetch(url))).events || [];
}
export async function acknowledgeEvent(alertEventId) {
  return jsonOrThrow(await window.authenticatedFetch(`api/v1/alerts/events/${encodeURIComponent(alertEventId)}/ack`, { method: 'POST' }));
}
